import React from 'react';
import { useAnalysisService } from '../services/analysis-service';

export const useAnalysisController = () => {
  const { getAnalysisService } = useAnalysisService();
  const [loading, setLoading] = React.useState(false);

  const getAnalysisDetail = React.useCallback(
    (id) => {
      setLoading(true);
      return getAnalysisService(id)
        .then((data) => data)
        .catch((error) => {
          console.error(error);
        })
        .finally(() => setLoading(false));
    },
    [getAnalysisService],
  );

  return {
    getAnalysisDetail,
    loading,
  };
};
